var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _path15, _path16, _defs, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polygon2, _path26, _path27, _path28, _defs2, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _polygon3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.28 51.85",
    style: {
      enableBackground: "new 0 0 40.28 51.85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n\t.st7{fill:url(#SVGID_8_);}\r\n\t.st8{fill:url(#SVGID_9_);}\r\n\t.st9{fill:url(#SVGID_10_);}\r\n\t.st10{fill:url(#SVGID_11_);}\r\n\t.st11{fill:url(#SVGID_12_);}\r\n\t.st12{fill:url(#SVGID_13_);}\r\n\t.st13{fill:url(#SVGID_14_);}\r\n\t.st14{fill:url(#SVGID_15_);}\r\n\t.st15{fill:url(#SVGID_16_);}\r\n\t.st16{fill:url(#SVGID_17_);}\r\n\t.st17{fill:url(#SVGID_18_);}\r\n\t.st18{fill:url(#SVGID_19_);}\r\n\t.st19{fill:url(#SVGID_20_);}\r\n\t.st20{fill:url(#SVGID_21_);}\r\n\t.st21{fill:url(#SVGID_22_);}\r\n\t.st22{fill:url(#SVGID_23_);}\r\n\t.st23{fill:url(#SVGID_24_);}\r\n\t.st24{fill:url(#SVGID_25_);}\r\n\t.st25{fill:url(#SVGID_26_);}\r\n\t.st26{fill:url(#SVGID_27_);}\r\n\t.st27{fill:url(#SVGID_28_);}\r\n\t.st28{fill:url(#SVGID_29_);}\r\n\t.st29{fill:url(#SVGID_30_);}\r\n\t.st30{fill:url(#SVGID_31_);}\r\n\t.st31{fill:url(#SVGID_32_);}\r\n\t.st32{fill:url(#SVGID_33_);}\r\n\t.st33{fill:url(#SVGID_34_);}\r\n\t.st34{fill:url(#SVGID_35_);}\r\n\t.st35{fill:url(#SVGID_36_);}\r\n\t.st36{fill:url(#SVGID_37_);}\r\n\t.st37{fill:#A87C4F;}\r\n\t.st38{fill:url(#SVGID_38_);}\r\n\t.st39{fill:url(#SVGID_39_);}\r\n\t.st40{fill:url(#SVGID_40_);}\r\n\t.st41{clip-path:url(#SVGID_42_);fill:#C4A274;}\r\n\t.st42{clip-path:url(#SVGID_42_);fill:#C5A375;}\r\n\t.st43{clip-path:url(#SVGID_42_);fill:#C6A475;}\r\n\t.st44{clip-path:url(#SVGID_42_);fill:#C7A577;}\r\n\t.st45{clip-path:url(#SVGID_42_);fill:#C8A677;}\r\n\t.st46{clip-path:url(#SVGID_42_);fill:#C8A778;}\r\n\t.st47{clip-path:url(#SVGID_42_);fill:#C9A879;}\r\n\t.st48{clip-path:url(#SVGID_42_);fill:#CAA97A;}\r\n\t.st49{clip-path:url(#SVGID_42_);fill:#CBAA7B;}\r\n\t.st50{clip-path:url(#SVGID_42_);fill:#CCAB7B;}\r\n\t.st51{clip-path:url(#SVGID_42_);fill:#CDAC7D;}\r\n\t.st52{clip-path:url(#SVGID_42_);fill:#CEAD7D;}\r\n\t.st53{clip-path:url(#SVGID_42_);fill:#CEAE7E;}\r\n\t.st54{clip-path:url(#SVGID_42_);fill:#CFAF7F;}\r\n\t.st55{clip-path:url(#SVGID_42_);fill:#D0B080;}\r\n\t.st56{clip-path:url(#SVGID_42_);fill:#D2B280;}\r\n\t.st57{clip-path:url(#SVGID_42_);fill:#D2B381;}\r\n\t.st58{clip-path:url(#SVGID_42_);fill:#D2B382;}\r\n\t.st59{clip-path:url(#SVGID_42_);fill:#D4B583;}\r\n\t.st60{clip-path:url(#SVGID_42_);fill:#D5B683;}\r\n\t.st61{clip-path:url(#SVGID_42_);fill:#D6B784;}\r\n\t.st62{clip-path:url(#SVGID_42_);fill:#D6B885;}\r\n\t.st63{clip-path:url(#SVGID_42_);fill:#D7B986;}\r\n\t.st64{clip-path:url(#SVGID_42_);fill:#D9BB87;}\r\n\t.st65{clip-path:url(#SVGID_42_);fill:#D9BB88;}\r\n\t.st66{clip-path:url(#SVGID_42_);fill:#DBBD89;}\r\n\t.st67{clip-path:url(#SVGID_42_);fill:#DCBE8A;}\r\n\t.st68{clip-path:url(#SVGID_42_);fill:#DCBF8A;}\r\n\t.st69{clip-path:url(#SVGID_42_);fill:#DDC08C;}\r\n\t.st70{clip-path:url(#SVGID_42_);fill:#DEC18D;}\r\n\t.st71{clip-path:url(#SVGID_42_);fill:#DFC38E;}\r\n\t.st72{clip-path:url(#SVGID_42_);fill:#E0C48F;}\r\n\t.st73{clip-path:url(#SVGID_42_);fill:#E2C590;}\r\n\t.st74{clip-path:url(#SVGID_42_);fill:#E3C691;}\r\n\t.st75{fill:url(#SVGID_43_);}\r\n\t.st76{fill:url(#SVGID_44_);}\r\n\t.st77{fill:url(#SVGID_45_);}\r\n\t.st78{fill:url(#SVGID_46_);}\r\n\t.st79{fill:url(#SVGID_47_);}\r\n\t.st80{fill:url(#SVGID_48_);}\r\n\t.st81{fill:url(#SVGID_49_);}\r\n\t.st82{fill:url(#SVGID_50_);}\r\n\t.st83{fill:url(#SVGID_51_);}\r\n\t.st84{fill:url(#SVGID_52_);}\r\n\t.st85{fill:url(#SVGID_53_);}\r\n\t.st86{clip-path:url(#SVGID_55_);fill:#C4A274;}\r\n\t.st87{clip-path:url(#SVGID_55_);fill:#C5A375;}\r\n\t.st88{clip-path:url(#SVGID_55_);fill:#C6A475;}\r\n\t.st89{clip-path:url(#SVGID_55_);fill:#C7A577;}\r\n\t.st90{clip-path:url(#SVGID_55_);fill:#C8A677;}\r\n\t.st91{clip-path:url(#SVGID_55_);fill:#C8A778;}\r\n\t.st92{clip-path:url(#SVGID_55_);fill:#C9A879;}\r\n\t.st93{clip-path:url(#SVGID_55_);fill:#CAA97A;}\r\n\t.st94{clip-path:url(#SVGID_55_);fill:#CBAA7B;}\r\n\t.st95{clip-path:url(#SVGID_55_);fill:#CCAB7B;}\r\n\t.st96{clip-path:url(#SVGID_55_);fill:#CDAC7D;}\r\n\t.st97{clip-path:url(#SVGID_55_);fill:#CEAD7D;}\r\n\t.st98{clip-path:url(#SVGID_55_);fill:#CEAE7E;}\r\n\t.st99{clip-path:url(#SVGID_55_);fill:#CFAF7F;}\r\n\t.st100{clip-path:url(#SVGID_55_);fill:#D0B080;}\r\n\t.st101{clip-path:url(#SVGID_55_);fill:#D2B280;}\r\n\t.st102{clip-path:url(#SVGID_55_);fill:#D2B381;}\r\n\t.st103{clip-path:url(#SVGID_55_);fill:#D2B382;}\r\n\t.st104{clip-path:url(#SVGID_55_);fill:#D4B583;}\r\n\t.st105{clip-path:url(#SVGID_55_);fill:#D5B683;}\r\n\t.st106{clip-path:url(#SVGID_55_);fill:#D6B784;}\r\n\t.st107{clip-path:url(#SVGID_55_);fill:#D6B885;}\r\n\t.st108{clip-path:url(#SVGID_55_);fill:#D7B986;}\r\n\t.st109{clip-path:url(#SVGID_55_);fill:#D9BB87;}\r\n\t.st110{clip-path:url(#SVGID_55_);fill:#D9BB88;}\r\n\t.st111{clip-path:url(#SVGID_55_);fill:#DBBD89;}\r\n\t.st112{clip-path:url(#SVGID_55_);fill:#DCBE8A;}\r\n\t.st113{clip-path:url(#SVGID_55_);fill:#DCBF8A;}\r\n\t.st114{clip-path:url(#SVGID_55_);fill:#DDC08C;}\r\n\t.st115{clip-path:url(#SVGID_55_);fill:#DEC18D;}\r\n\t.st116{clip-path:url(#SVGID_55_);fill:#DFC38E;}\r\n\t.st117{clip-path:url(#SVGID_55_);fill:#E0C48F;}\r\n\t.st118{clip-path:url(#SVGID_55_);fill:#E2C590;}\r\n\t.st119{clip-path:url(#SVGID_55_);fill:#E3C691;}\r\n\t.st120{fill:url(#SVGID_56_);}\r\n\t.st121{fill:url(#SVGID_57_);}\r\n\t.st122{fill:url(#SVGID_58_);}\r\n\t.st123{fill:url(#SVGID_59_);}\r\n\t.st124{fill:url(#SVGID_60_);}\r\n\t.st125{fill:url(#SVGID_61_);}\r\n\t.st126{fill:url(#SVGID_62_);}\r\n\t.st127{fill:url(#SVGID_63_);}\r\n\t.st128{fill:url(#SVGID_64_);}\r\n\t.st129{fill:url(#SVGID_65_);}\r\n\t.st130{fill:url(#SVGID_66_);}\r\n\t.st131{fill:url(#SVGID_67_);}\r\n\t.st132{fill:url(#SVGID_68_);}\r\n\t.st133{fill:url(#SVGID_69_);}\r\n\t.st134{fill:url(#SVGID_70_);}\r\n\t.st135{fill:url(#SVGID_71_);}\r\n\t.st136{fill:url(#SVGID_72_);}\r\n\t.st137{fill:url(#SVGID_73_);}\r\n\t.st138{fill:url(#SVGID_74_);}\r\n\t.st139{fill:url(#SVGID_75_);}\r\n\t.st140{fill:url(#SVGID_76_);}\r\n\t.st141{fill:url(#SVGID_77_);}\r\n\t.st142{fill:url(#SVGID_78_);}\r\n\t.st143{fill:url(#SVGID_79_);}\r\n\t.st144{fill:#6E6E6E;}\r\n\t.st145{fill:url(#SVGID_80_);}\r\n\t.st146{fill:url(#SVGID_81_);}\r\n\t.st147{fill:url(#SVGID_82_);}\r\n\t.st148{clip-path:url(#SVGID_84_);fill:#9F9F9F;}\r\n\t.st149{clip-path:url(#SVGID_84_);fill:#A0A0A0;}\r\n\t.st150{clip-path:url(#SVGID_84_);fill:#A2A2A2;}\r\n\t.st151{clip-path:url(#SVGID_84_);fill:#A3A3A3;}\r\n\t.st152{clip-path:url(#SVGID_84_);fill:#A4A4A4;}\r\n\t.st153{clip-path:url(#SVGID_84_);fill:#A6A6A6;}\r\n\t.st154{clip-path:url(#SVGID_84_);fill:#A7A7A7;}\r\n\t.st155{clip-path:url(#SVGID_84_);fill:#A8A8A8;}\r\n\t.st156{clip-path:url(#SVGID_84_);fill:#AAAAAA;}\r\n\t.st157{clip-path:url(#SVGID_84_);fill:#ABABAB;}\r\n\t.st158{clip-path:url(#SVGID_84_);fill:#ACACAC;}\r\n\t.st159{clip-path:url(#SVGID_84_);fill:#ADADAD;}\r\n\t.st160{clip-path:url(#SVGID_84_);fill:#AFAFAF;}\r\n\t.st161{clip-path:url(#SVGID_84_);fill:#B0B0B0;}\r\n\t.st162{clip-path:url(#SVGID_84_);fill:#B1B1B1;}\r\n\t.st163{clip-path:url(#SVGID_84_);fill:#B3B3B3;}\r\n\t.st164{clip-path:url(#SVGID_84_);fill:#B4B4B4;}\r\n\t.st165{clip-path:url(#SVGID_84_);fill:#B5B5B5;}\r\n\t.st166{clip-path:url(#SVGID_84_);fill:#B7B7B7;}\r\n\t.st167{clip-path:url(#SVGID_84_);fill:#B8B8B8;}\r\n\t.st168{clip-path:url(#SVGID_84_);fill:#B9B9B9;}\r\n\t.st169{clip-path:url(#SVGID_84_);fill:#BABABA;}\r\n\t.st170{clip-path:url(#SVGID_84_);fill:#BCBCBC;}\r\n\t.st171{clip-path:url(#SVGID_84_);fill:#BDBDBD;}\r\n\t.st172{clip-path:url(#SVGID_84_);fill:#BEBEBE;}\r\n\t.st173{clip-path:url(#SVGID_84_);fill:#C0C0C0;}\r\n\t.st174{clip-path:url(#SVGID_84_);fill:#C1C1C1;}\r\n\t.st175{clip-path:url(#SVGID_84_);fill:#C2C2C2;}\r\n\t.st176{clip-path:url(#SVGID_84_);fill:#C4C4C4;}\r\n\t.st177{clip-path:url(#SVGID_84_);fill:#C5C5C5;}\r\n\t.st178{clip-path:url(#SVGID_84_);fill:#C6C6C6;}\r\n\t.st179{clip-path:url(#SVGID_84_);fill:#C8C8C8;}\r\n\t.st180{clip-path:url(#SVGID_84_);fill:#C9C9C9;}\r\n\t.st181{clip-path:url(#SVGID_84_);fill:#CACACA;}\r\n\t.st182{fill:url(#SVGID_85_);}\r\n\t.st183{fill:url(#SVGID_86_);}\r\n\t.st184{fill:url(#SVGID_87_);}\r\n\t.st185{fill:url(#SVGID_88_);}\r\n\t.st186{fill:url(#SVGID_89_);}\r\n\t.st187{fill:url(#SVGID_90_);}\r\n\t.st188{fill:url(#SVGID_91_);}\r\n\t.st189{fill:url(#SVGID_92_);}\r\n\t.st190{fill:url(#SVGID_93_);}\r\n\t.st191{fill:url(#SVGID_94_);}\r\n\t.st192{fill:url(#SVGID_95_);}\r\n\t.st193{clip-path:url(#SVGID_97_);fill:#9F9F9F;}\r\n\t.st194{clip-path:url(#SVGID_97_);fill:#A0A0A0;}\r\n\t.st195{clip-path:url(#SVGID_97_);fill:#A2A2A2;}\r\n\t.st196{clip-path:url(#SVGID_97_);fill:#A3A3A3;}\r\n\t.st197{clip-path:url(#SVGID_97_);fill:#A4A4A4;}\r\n\t.st198{clip-path:url(#SVGID_97_);fill:#A6A6A6;}\r\n\t.st199{clip-path:url(#SVGID_97_);fill:#A7A7A7;}\r\n\t.st200{clip-path:url(#SVGID_97_);fill:#A8A8A8;}\r\n\t.st201{clip-path:url(#SVGID_97_);fill:#AAAAAA;}\r\n\t.st202{clip-path:url(#SVGID_97_);fill:#ABABAB;}\r\n\t.st203{clip-path:url(#SVGID_97_);fill:#ACACAC;}\r\n\t.st204{clip-path:url(#SVGID_97_);fill:#ADADAD;}\r\n\t.st205{clip-path:url(#SVGID_97_);fill:#AFAFAF;}\r\n\t.st206{clip-path:url(#SVGID_97_);fill:#B0B0B0;}\r\n\t.st207{clip-path:url(#SVGID_97_);fill:#B1B1B1;}\r\n\t.st208{clip-path:url(#SVGID_97_);fill:#B3B3B3;}\r\n\t.st209{clip-path:url(#SVGID_97_);fill:#B4B4B4;}\r\n\t.st210{clip-path:url(#SVGID_97_);fill:#B5B5B5;}\r\n\t.st211{clip-path:url(#SVGID_97_);fill:#B7B7B7;}\r\n\t.st212{clip-path:url(#SVGID_97_);fill:#B8B8B8;}\r\n\t.st213{clip-path:url(#SVGID_97_);fill:#B9B9B9;}\r\n\t.st214{clip-path:url(#SVGID_97_);fill:#BABABA;}\r\n\t.st215{clip-path:url(#SVGID_97_);fill:#BCBCBC;}\r\n\t.st216{clip-path:url(#SVGID_97_);fill:#BDBDBD;}\r\n\t.st217{clip-path:url(#SVGID_97_);fill:#BEBEBE;}\r\n\t.st218{clip-path:url(#SVGID_97_);fill:#C0C0C0;}\r\n\t.st219{clip-path:url(#SVGID_97_);fill:#C1C1C1;}\r\n\t.st220{clip-path:url(#SVGID_97_);fill:#C2C2C2;}\r\n\t.st221{clip-path:url(#SVGID_97_);fill:#C4C4C4;}\r\n\t.st222{clip-path:url(#SVGID_97_);fill:#C5C5C5;}\r\n\t.st223{clip-path:url(#SVGID_97_);fill:#C6C6C6;}\r\n\t.st224{clip-path:url(#SVGID_97_);fill:#C8C8C8;}\r\n\t.st225{clip-path:url(#SVGID_97_);fill:#C9C9C9;}\r\n\t.st226{clip-path:url(#SVGID_97_);fill:#CACACA;}\r\n\t.st227{fill:url(#SVGID_98_);}\r\n\t.st228{fill:url(#SVGID_99_);}\r\n\t.st229{fill:url(#SVGID_100_);}\r\n\t.st230{fill:url(#SVGID_101_);}\r\n\t.st231{fill:url(#SVGID_102_);}\r\n\t.st232{fill:url(#SVGID_103_);}\r\n\t.st233{fill:url(#SVGID_104_);}\r\n\t.st234{fill:url(#SVGID_105_);}\r\n\t.st235{fill:url(#SVGID_106_);}\r\n\t.st236{fill:url(#SVGID_107_);}\r\n\t.st237{fill:url(#SVGID_108_);}\r\n\t.st238{fill:url(#SVGID_109_);}\r\n\t.st239{fill:url(#SVGID_110_);}\r\n\t.st240{fill:url(#SVGID_111_);}\r\n\t.st241{fill:url(#SVGID_112_);}\r\n\t.st242{fill:url(#SVGID_113_);}\r\n\t.st243{fill:url(#SVGID_114_);}\r\n\t.st244{fill:url(#SVGID_115_);}\r\n\t.st245{fill:url(#SVGID_116_);}\r\n\t.st246{fill:url(#SVGID_117_);}\r\n\t.st247{fill:url(#SVGID_118_);}\r\n\t.st248{fill:url(#SVGID_119_);}\r\n\t.st249{fill:url(#SVGID_120_);}\r\n\t.st250{fill:url(#SVGID_121_);}\r\n\t.st251{fill:url(#SVGID_122_);}\r\n\t.st252{fill:url(#SVGID_123_);}\r\n\t.st253{fill:url(#SVGID_124_);}\r\n\t.st254{fill:url(#SVGID_125_);}\r\n\t.st255{fill:#64648B;}\r\n\t.st256{fill:url(#SVGID_126_);}\r\n\t.st257{fill:url(#SVGID_127_);}\r\n\t.st258{fill:url(#SVGID_128_);}\r\n\t.st259{clip-path:url(#SVGID_130_);fill:#9595BC;}\r\n\t.st260{clip-path:url(#SVGID_130_);fill:#9696BD;}\r\n\t.st261{clip-path:url(#SVGID_130_);fill:#9798BE;}\r\n\t.st262{clip-path:url(#SVGID_130_);fill:#9999BF;}\r\n\t.st263{clip-path:url(#SVGID_130_);fill:#9A9AC1;}\r\n\t.st264{clip-path:url(#SVGID_130_);fill:#9B9CC2;}\r\n\t.st265{clip-path:url(#SVGID_130_);fill:#9D9DC3;}\r\n\t.st266{clip-path:url(#SVGID_130_);fill:#9E9EC5;}\r\n\t.st267{clip-path:url(#SVGID_130_);fill:#9FA0C6;}\r\n\t.st268{clip-path:url(#SVGID_130_);fill:#A1A1C7;}\r\n\t.st269{clip-path:url(#SVGID_130_);fill:#A2A2C9;}\r\n\t.st270{clip-path:url(#SVGID_130_);fill:#A3A3CA;}\r\n\t.st271{clip-path:url(#SVGID_130_);fill:#A5A5CB;}\r\n\t.st272{clip-path:url(#SVGID_130_);fill:#A6A6CD;}\r\n\t.st273{clip-path:url(#SVGID_130_);fill:#A7A7CE;}\r\n\t.st274{clip-path:url(#SVGID_130_);fill:#A8A9CF;}\r\n\t.st275{clip-path:url(#SVGID_130_);fill:#AAAAD0;}\r\n\t.st276{clip-path:url(#SVGID_130_);fill:#ABABD2;}\r\n\t.st277{clip-path:url(#SVGID_130_);fill:#ACADD3;}\r\n\t.st278{clip-path:url(#SVGID_130_);fill:#AEAED4;}\r\n\t.st279{clip-path:url(#SVGID_130_);fill:#AFAFD6;}\r\n\t.st280{clip-path:url(#SVGID_130_);fill:#B0B0D7;}\r\n\t.st281{clip-path:url(#SVGID_130_);fill:#B2B2D8;}\r\n\t.st282{clip-path:url(#SVGID_130_);fill:#B3B3DA;}\r\n\t.st283{clip-path:url(#SVGID_130_);fill:#B4B4DB;}\r\n\t.st284{clip-path:url(#SVGID_130_);fill:#B6B6DC;}\r\n\t.st285{clip-path:url(#SVGID_130_);fill:#B7B7DE;}\r\n\t.st286{clip-path:url(#SVGID_130_);fill:#B8B8DF;}\r\n\t.st287{clip-path:url(#SVGID_130_);fill:#B9BAE0;}\r\n\t.st288{clip-path:url(#SVGID_130_);fill:#BBBBE1;}\r\n\t.st289{clip-path:url(#SVGID_130_);fill:#BCBCE3;}\r\n\t.st290{clip-path:url(#SVGID_130_);fill:#BDBEE4;}\r\n\t.st291{clip-path:url(#SVGID_130_);fill:#BFBFE5;}\r\n\t.st292{clip-path:url(#SVGID_130_);fill:#C0C0E7;}\r\n\t.st293{fill:url(#SVGID_131_);}\r\n\t.st294{fill:url(#SVGID_132_);}\r\n\t.st295{fill:url(#SVGID_133_);}\r\n\t.st296{fill:url(#SVGID_134_);}\r\n\t.st297{fill:url(#SVGID_135_);}\r\n\t.st298{fill:url(#SVGID_136_);}\r\n\t.st299{fill:url(#SVGID_137_);}\r\n\t.st300{fill:url(#SVGID_138_);}\r\n\t.st301{fill:url(#SVGID_139_);}\r\n\t.st302{fill:url(#SVGID_140_);}\r\n\t.st303{fill:url(#SVGID_141_);}\r\n\t.st304{clip-path:url(#SVGID_143_);fill:#9595BC;}\r\n\t.st305{clip-path:url(#SVGID_143_);fill:#9696BD;}\r\n\t.st306{clip-path:url(#SVGID_143_);fill:#9798BE;}\r\n\t.st307{clip-path:url(#SVGID_143_);fill:#9999BF;}\r\n\t.st308{clip-path:url(#SVGID_143_);fill:#9A9AC1;}\r\n\t.st309{clip-path:url(#SVGID_143_);fill:#9B9CC2;}\r\n\t.st310{clip-path:url(#SVGID_143_);fill:#9D9DC3;}\r\n\t.st311{clip-path:url(#SVGID_143_);fill:#9E9EC5;}\r\n\t.st312{clip-path:url(#SVGID_143_);fill:#9FA0C6;}\r\n\t.st313{clip-path:url(#SVGID_143_);fill:#A1A1C7;}\r\n\t.st314{clip-path:url(#SVGID_143_);fill:#A2A2C9;}\r\n\t.st315{clip-path:url(#SVGID_143_);fill:#A3A3CA;}\r\n\t.st316{clip-path:url(#SVGID_143_);fill:#A5A5CB;}\r\n\t.st317{clip-path:url(#SVGID_143_);fill:#A6A6CD;}\r\n\t.st318{clip-path:url(#SVGID_143_);fill:#A7A7CE;}\r\n\t.st319{clip-path:url(#SVGID_143_);fill:#A8A9CF;}\r\n\t.st320{clip-path:url(#SVGID_143_);fill:#AAAAD0;}\r\n\t.st321{clip-path:url(#SVGID_143_);fill:#ABABD2;}\r\n\t.st322{clip-path:url(#SVGID_143_);fill:#ACADD3;}\r\n\t.st323{clip-path:url(#SVGID_143_);fill:#AEAED4;}\r\n\t.st324{clip-path:url(#SVGID_143_);fill:#AFAFD6;}\r\n\t.st325{clip-path:url(#SVGID_143_);fill:#B0B0D7;}\r\n\t.st326{clip-path:url(#SVGID_143_);fill:#B2B2D8;}\r\n\t.st327{clip-path:url(#SVGID_143_);fill:#B3B3DA;}\r\n\t.st328{clip-path:url(#SVGID_143_);fill:#B4B4DB;}\r\n\t.st329{clip-path:url(#SVGID_143_);fill:#B6B6DC;}\r\n\t.st330{clip-path:url(#SVGID_143_);fill:#B7B7DE;}\r\n\t.st331{clip-path:url(#SVGID_143_);fill:#B8B8DF;}\r\n\t.st332{clip-path:url(#SVGID_143_);fill:#B9BAE0;}\r\n\t.st333{clip-path:url(#SVGID_143_);fill:#BBBBE1;}\r\n\t.st334{clip-path:url(#SVGID_143_);fill:#BCBCE3;}\r\n\t.st335{clip-path:url(#SVGID_143_);fill:#BDBEE4;}\r\n\t.st336{clip-path:url(#SVGID_143_);fill:#BFBFE5;}\r\n\t.st337{clip-path:url(#SVGID_143_);fill:#C0C0E7;}\r\n\t.st338{fill:url(#SVGID_144_);}\r\n\t.st339{fill:url(#SVGID_145_);}\r\n\t.st340{fill:url(#SVGID_146_);}\r\n\t.st341{fill:url(#SVGID_147_);}\r\n\t.st342{fill:url(#SVGID_148_);}\r\n\t.st343{fill:url(#SVGID_149_);}\r\n\t.st344{fill:url(#SVGID_150_);}\r\n\t.st345{fill:url(#SVGID_151_);}\r\n\t.st346{fill:url(#SVGID_152_);}\r\n\t.st347{fill:url(#SVGID_153_);}\r\n\t.st348{fill:url(#SVGID_154_);}\r\n\t.st349{fill:url(#SVGID_155_);}\r\n\t.st350{fill:url(#SVGID_156_);}\r\n\t.st351{fill:url(#SVGID_157_);}\r\n\t.st352{fill:url(#SVGID_158_);}\r\n\t.st353{fill:url(#SVGID_159_);}\r\n\t.st354{fill:url(#SVGID_160_);}\r\n\t.st355{fill:url(#SVGID_161_);}\r\n\t.st356{fill:url(#SVGID_162_);}\r\n\t.st357{fill:url(#SVGID_163_);}\r\n\t.st358{fill:url(#SVGID_164_);}\r\n\t.st359{fill:url(#SVGID_165_);}\r\n\t.st360{fill:url(#SVGID_166_);}\r\n\t.st361{fill:url(#SVGID_167_);}\r\n\t.st362{fill:url(#SVGID_168_);}\r\n\t.st363{fill:url(#SVGID_169_);}\r\n\t.st364{fill:#9F694B;}\r\n\t.st365{fill:url(#SVGID_170_);}\r\n\t.st366{fill:url(#SVGID_171_);}\r\n\t.st367{fill:url(#SVGID_172_);}\r\n\t.st368{clip-path:url(#SVGID_174_);fill:#D09A7C;}\r\n\t.st369{clip-path:url(#SVGID_174_);fill:#D19B7D;}\r\n\t.st370{clip-path:url(#SVGID_174_);fill:#D29D7E;}\r\n\t.st371{clip-path:url(#SVGID_174_);fill:#D49E7F;}\r\n\t.st372{clip-path:url(#SVGID_174_);fill:#D59F81;}\r\n\t.st373{clip-path:url(#SVGID_174_);fill:#D6A182;}\r\n\t.st374{clip-path:url(#SVGID_174_);fill:#D8A283;}\r\n\t.st375{clip-path:url(#SVGID_174_);fill:#D9A385;}\r\n\t.st376{clip-path:url(#SVGID_174_);fill:#DAA586;}\r\n\t.st377{clip-path:url(#SVGID_174_);fill:#DCA687;}\r\n\t.st378{clip-path:url(#SVGID_174_);fill:#DDA789;}\r\n\t.st379{clip-path:url(#SVGID_174_);fill:#DEA88A;}\r\n\t.st380{clip-path:url(#SVGID_174_);fill:#E0AA8B;}\r\n\t.st381{clip-path:url(#SVGID_174_);fill:#E1AB8D;}\r\n\t.st382{clip-path:url(#SVGID_174_);fill:#E2AC8E;}\r\n\t.st383{clip-path:url(#SVGID_174_);fill:#E3AE8F;}\r\n\t.st384{clip-path:url(#SVGID_174_);fill:#E5AF90;}\r\n\t.st385{clip-path:url(#SVGID_174_);fill:#E6B092;}\r\n\t.st386{clip-path:url(#SVGID_174_);fill:#E7B293;}\r\n\t.st387{clip-path:url(#SVGID_174_);fill:#E9B394;}\r\n\t.st388{clip-path:url(#SVGID_174_);fill:#EAB496;}\r\n\t.st389{clip-path:url(#SVGID_174_);fill:#EBB597;}\r\n\t.st390{clip-path:url(#SVGID_174_);fill:#EDB798;}\r\n\t.st391{clip-path:url(#SVGID_174_);fill:#EEB89A;}\r\n\t.st392{clip-path:url(#SVGID_174_);fill:#EFB99B;}\r\n\t.st393{clip-path:url(#SVGID_174_);fill:#F1BB9C;}\r\n\t.st394{clip-path:url(#SVGID_174_);fill:#F2BC9E;}\r\n\t.st395{clip-path:url(#SVGID_174_);fill:#F3BD9F;}\r\n\t.st396{clip-path:url(#SVGID_174_);fill:#F4BFA0;}\r\n\t.st397{clip-path:url(#SVGID_174_);fill:#F6C0A1;}\r\n\t.st398{clip-path:url(#SVGID_174_);fill:#F7C1A3;}\r\n\t.st399{clip-path:url(#SVGID_174_);fill:#F8C3A4;}\r\n\t.st400{clip-path:url(#SVGID_174_);fill:#FAC4A5;}\r\n\t.st401{clip-path:url(#SVGID_174_);fill:#FBC5A7;}\r\n\t.st402{fill:url(#SVGID_175_);}\r\n\t.st403{fill:url(#SVGID_176_);}\r\n\t.st404{fill:url(#SVGID_177_);}\r\n\t.st405{fill:url(#SVGID_178_);}\r\n\t.st406{fill:url(#SVGID_179_);}\r\n\t.st407{fill:url(#SVGID_180_);}\r\n\t.st408{fill:url(#SVGID_181_);}\r\n\t.st409{fill:url(#SVGID_182_);}\r\n\t.st410{fill:url(#SVGID_183_);}\r\n\t.st411{fill:url(#SVGID_184_);}\r\n\t.st412{fill:url(#SVGID_185_);}\r\n\t.st413{clip-path:url(#SVGID_187_);fill:#D09A7C;}\r\n\t.st414{clip-path:url(#SVGID_187_);fill:#D19B7D;}\r\n\t.st415{clip-path:url(#SVGID_187_);fill:#D29D7E;}\r\n\t.st416{clip-path:url(#SVGID_187_);fill:#D49E7F;}\r\n\t.st417{clip-path:url(#SVGID_187_);fill:#D59F81;}\r\n\t.st418{clip-path:url(#SVGID_187_);fill:#D6A182;}\r\n\t.st419{clip-path:url(#SVGID_187_);fill:#D8A283;}\r\n\t.st420{clip-path:url(#SVGID_187_);fill:#D9A385;}\r\n\t.st421{clip-path:url(#SVGID_187_);fill:#DAA586;}\r\n\t.st422{clip-path:url(#SVGID_187_);fill:#DCA687;}\r\n\t.st423{clip-path:url(#SVGID_187_);fill:#DDA789;}\r\n\t.st424{clip-path:url(#SVGID_187_);fill:#DEA88A;}\r\n\t.st425{clip-path:url(#SVGID_187_);fill:#E0AA8B;}\r\n\t.st426{clip-path:url(#SVGID_187_);fill:#E1AB8D;}\r\n\t.st427{clip-path:url(#SVGID_187_);fill:#E2AC8E;}\r\n\t.st428{clip-path:url(#SVGID_187_);fill:#E3AE8F;}\r\n\t.st429{clip-path:url(#SVGID_187_);fill:#E5AF90;}\r\n\t.st430{clip-path:url(#SVGID_187_);fill:#E6B092;}\r\n\t.st431{clip-path:url(#SVGID_187_);fill:#E7B293;}\r\n\t.st432{clip-path:url(#SVGID_187_);fill:#E9B394;}\r\n\t.st433{clip-path:url(#SVGID_187_);fill:#EAB496;}\r\n\t.st434{clip-path:url(#SVGID_187_);fill:#EBB597;}\r\n\t.st435{clip-path:url(#SVGID_187_);fill:#EDB798;}\r\n\t.st436{clip-path:url(#SVGID_187_);fill:#EEB89A;}\r\n\t.st437{clip-path:url(#SVGID_187_);fill:#EFB99B;}\r\n\t.st438{clip-path:url(#SVGID_187_);fill:#F1BB9C;}\r\n\t.st439{clip-path:url(#SVGID_187_);fill:#F2BC9E;}\r\n\t.st440{clip-path:url(#SVGID_187_);fill:#F3BD9F;}\r\n\t.st441{clip-path:url(#SVGID_187_);fill:#F4BFA0;}\r\n\t.st442{clip-path:url(#SVGID_187_);fill:#F6C0A1;}\r\n\t.st443{clip-path:url(#SVGID_187_);fill:#F7C1A3;}\r\n\t.st444{clip-path:url(#SVGID_187_);fill:#F8C3A4;}\r\n\t.st445{clip-path:url(#SVGID_187_);fill:#FAC4A5;}\r\n\t.st446{clip-path:url(#SVGID_187_);fill:#FBC5A7;}\r\n\t.st447{fill:url(#SVGID_188_);}\r\n\t.st448{fill:url(#SVGID_189_);}\r\n\t.st449{fill:url(#SVGID_190_);}\r\n\t.st450{fill:url(#SVGID_191_);}\r\n\t.st451{fill:url(#SVGID_192_);}\r\n\t.st452{fill:url(#SVGID_193_);}\r\n\t.st453{fill:url(#SVGID_194_);}\r\n\t.st454{fill:url(#SVGID_195_);}\r\n\t.st455{fill:url(#SVGID_196_);}\r\n\t.st456{fill:url(#SVGID_197_);}\r\n\t.st457{fill:url(#SVGID_198_);}\r\n\t.st458{fill:url(#SVGID_199_);}\r\n\t.st459{fill:url(#SVGID_200_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.1438,
    y1: 1.6807,
    x2: 27.6892,
    y2: 29.0739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.2,17.41l-5.6,4.07c-0.41,0.3-0.59,0.84-0.43,1.32l0.38,1.17l1.76,5.42c0.35,1.09-0.9,2-1.83,1.33 l-5.01-3.64l-0.59-0.43c-0.42-0.3-0.98-0.3-1.4,0l-5.6,4.07c-0.79,0.57-1.8,0.01-1.88-0.84c-0.02-0.15,0-0.32,0.06-0.49l2.14-6.59 c0.16-0.49-0.02-1.02-0.43-1.32l-5.6-4.07c-0.93-0.68-0.45-2.14,0.7-2.15h6.92c0.51,0,0.97-0.33,1.13-0.82l2.14-6.58 c0.18-0.55,0.67-0.83,1.15-0.82c0.47,0.01,0.93,0.28,1.1,0.82l2.14,6.58c0.16,0.49,0.61,0.82,1.13,0.82h6.92 C32.65,15.27,33.13,16.74,32.2,17.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0143,
    y1: 19.076,
    x2: 23.3199,
    y2: 16.3443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.39,20.25c0.81-2.15,1.22-4.42,1.22-6.75c0-2.08-0.33-4.12-0.97-6.07c0.18,0.1,0.33,0.26,0.41,0.51 l2.14,6.58c0.19,0.6,0.75,1.01,1.39,1.01h3.6C26.53,18.32,23.61,20.09,20.39,20.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9439,
    y1: 7.1481,
    x2: 8.1654,
    y2: 30.5611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFF0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D49E80"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.33,13.5c0,2.49-0.48,4.86-1.35,7.04c-1.56,3.93-4.39,7.21-7.99,9.34c-0.01-0.09-0.01-0.18,0.01-0.28 c0.01-0.07,0.03-0.14,0.05-0.21l0.13-0.41c3.06-2.08,5.49-5.02,6.93-8.48c0.01-0.02,0.02-0.05,0.03-0.07 c0.05-0.11,0.1-0.23,0.14-0.35c0.11-0.29,0.22-0.58,0.32-0.88c0.05-0.14,0.09-0.29,0.14-0.43c0.05-0.14,0.09-0.28,0.12-0.42 c0.01-0.02,0.02-0.05,0.02-0.07c0.04-0.13,0.07-0.26,0.1-0.39c0.08-0.31,0.15-0.62,0.21-0.93c0.03-0.14,0.06-0.28,0.08-0.43 c0,0,0-0.01,0-0.01c0.02-0.13,0.04-0.26,0.06-0.39c0.01-0.08,0.02-0.15,0.03-0.23c0.02-0.1,0.03-0.2,0.04-0.3 c0.02-0.16,0.04-0.31,0.05-0.47c0.02-0.14,0.03-0.27,0.04-0.41c0.01-0.03,0.01-0.07,0.01-0.1c0.01-0.1,0.02-0.21,0.02-0.32 c0.01-0.15,0.02-0.31,0.02-0.47c0.01-0.2,0.01-0.41,0.01-0.61c0-2.1-0.34-4.13-0.97-6.02c0.19-0.11,0.4-0.16,0.62-0.15 C20.93,9.06,21.33,11.23,21.33,13.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.7069,
    y1: 17.3144,
    x2: 33.6377,
    y2: 29.8061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.56,13.21c0,2.58-0.52,5.05-1.45,7.3c-1.44,3.46-3.86,6.4-6.93,8.48l2.01-6.18 c0.16-0.49-0.02-1.02-0.43-1.32l-5.6-4.07c-0.93-0.68-0.45-2.14,0.7-2.15h6.92c0.51,0,0.97-0.33,1.13-0.82l1.03-3.16l1.12-3.43 c0.02-0.05,0.03-0.09,0.05-0.14c0.01-0.03,0.03-0.06,0.04-0.08c0.02-0.03,0.03-0.06,0.05-0.09c0-0.01,0.01-0.01,0.01-0.02 c0.02-0.03,0.04-0.05,0.06-0.08c0.02-0.03,0.05-0.06,0.07-0.08c0.02-0.02,0.05-0.05,0.08-0.07c0.02-0.02,0.05-0.04,0.07-0.06 c0.03-0.02,0.07-0.04,0.1-0.06C20.22,9.09,20.56,11.11,20.56,13.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.9808,
    y1: 19.2812,
    x2: -2.4034,
    y2: 11.5769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.72,22.98c0.23-0.72-0.02-1.5-0.63-1.94l-5.6-4.07c-0.35-0.25-0.26-0.61-0.23-0.71 c0.03-0.1,0.18-0.44,0.61-0.44h6.92c0.76,0,1.42-0.48,1.65-1.2l1.98-6.07c0.4,1.52,0.6,3.09,0.6,4.67c0,2.45-0.47,4.84-1.41,7.08 c-1.17,2.82-3,5.28-5.35,7.21L14.72,22.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.1549,
    y1: 25.7489,
    x2: 29.1312,
    y2: 35.9089
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.17,30.68c-0.19,0-0.37-0.06-0.53-0.18l-4.77-3.46c1.2-1.32,2.77-2.28,4.49-2.73l1.68,5.17 c0.09,0.29,0.05,0.57-0.12,0.81C27.75,30.53,27.46,30.68,27.17,30.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.4498,
    y1: 36.4609,
    x2: -0.4657,
    y2: -6.4689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.14,0.27c-0.35,0-0.7,0.01-1.04,0.03c-0.89,0.04-1.77,0.15-2.63,0.31c-2.34,0.43-4.53,1.27-6.51,2.43 C8.97,3.62,8.03,4.29,7.15,5.03c-2.82,2.38-4.97,5.52-6.15,9.1C0.35,16.1,0,18.21,0,20.4c0,3.53,0.91,6.85,2.52,9.74 c3.44,6.2,10.05,10.4,17.62,10.4c11.11,0,20.14-9.03,20.14-20.14C40.28,9.3,31.24,0.27,20.14,0.27z M20.14,38.47 c-6.7,0-12.55-3.65-15.67-9.07c-1.53-2.65-2.4-5.73-2.4-9c0-0.19,0-0.39,0.01-0.58c0-0.15,0.01-0.31,0.02-0.47 c0-0.09,0.01-0.18,0.02-0.28c0.01-0.12,0.02-0.24,0.03-0.36c0.02-0.21,0.04-0.42,0.07-0.63c0.01-0.09,0.02-0.18,0.04-0.28 c0.02-0.16,0.05-0.32,0.07-0.48c0.03-0.18,0.06-0.35,0.1-0.53c0.05-0.25,0.1-0.49,0.16-0.73c0.04-0.16,0.08-0.32,0.12-0.47 c0-0.02,0.01-0.04,0.01-0.05c0.05-0.18,0.1-0.35,0.15-0.53c0.02-0.05,0.03-0.1,0.05-0.14c0.04-0.13,0.08-0.26,0.13-0.39 c0.01-0.02,0.02-0.05,0.02-0.07c0.01-0.02,0.01-0.04,0.02-0.06c0.05-0.15,0.11-0.3,0.16-0.45c0.01-0.02,0.02-0.04,0.02-0.06 c0.06-0.17,0.13-0.34,0.2-0.5c0-0.01,0.01-0.02,0.01-0.03c0.08-0.18,0.16-0.36,0.24-0.54c0.07-0.16,0.15-0.32,0.23-0.48 C3.99,12.3,4,12.28,4.01,12.25c0.08-0.15,0.16-0.31,0.24-0.46c0.01-0.01,0.01-0.02,0.02-0.04c0.09-0.17,0.19-0.34,0.29-0.51 c0.1-0.17,0.2-0.33,0.3-0.49c0,0,0.01-0.01,0.01-0.01c0.09-0.15,0.19-0.3,0.29-0.44c0.01-0.02,0.03-0.04,0.04-0.06 c0.11-0.15,0.22-0.31,0.33-0.46c0.11-0.16,0.23-0.31,0.35-0.46C5.98,9.18,6.09,9.05,6.2,8.91c0.02-0.03,0.05-0.06,0.07-0.09 c0.11-0.14,0.23-0.27,0.35-0.4c0.26-0.29,0.52-0.57,0.8-0.84c0.14-0.14,0.27-0.27,0.41-0.4c0,0,0.01,0,0.01-0.01 c0.14-0.13,0.28-0.26,0.43-0.39C8.28,6.77,8.3,6.76,8.31,6.74c0.13-0.11,0.26-0.22,0.39-0.33C8.85,6.3,8.99,6.19,9.13,6.08 c0.02-0.02,0.04-0.04,0.06-0.05c0.14-0.1,0.28-0.21,0.42-0.31c0.15-0.1,0.3-0.21,0.45-0.31c0.03-0.02,0.06-0.04,0.09-0.06 c0.14-0.09,0.27-0.18,0.41-0.27c0.02-0.01,0.04-0.03,0.06-0.04c0.13-0.08,0.26-0.16,0.39-0.23c0.04-0.02,0.08-0.05,0.12-0.07 c0.13-0.07,0.25-0.14,0.38-0.21c0.13-0.07,0.26-0.14,0.39-0.2c0.1-0.05,0.2-0.1,0.31-0.15c0.1-0.05,0.21-0.1,0.31-0.15 c0.15-0.07,0.3-0.14,0.45-0.2c0.09-0.04,0.19-0.08,0.28-0.12c0.09-0.04,0.18-0.08,0.28-0.11c0.1-0.04,0.19-0.07,0.29-0.11 c0.17-0.06,0.33-0.12,0.5-0.18c0.11-0.04,0.22-0.07,0.33-0.11c0.7-0.22,1.42-0.4,2.16-0.54c0.14-0.02,0.27-0.05,0.41-0.07 c0.12-0.02,0.24-0.04,0.36-0.05c0.12-0.02,0.23-0.03,0.35-0.05c0.14-0.02,0.29-0.03,0.44-0.05c0.14-0.01,0.29-0.03,0.43-0.04 c0.13-0.01,0.26-0.02,0.39-0.02c0.15-0.01,0.3-0.01,0.45-0.02h0.02c0.15,0,0.31-0.01,0.46-0.01c9.98,0,18.07,8.09,18.07,18.07 S30.12,38.47,20.14,38.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.7663,
    y1: 6.673,
    x2: 48.0597,
    y2: 51.3916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.14,2.34c-0.15,0-0.31,0-0.46,0.01h-0.02c-0.15,0.01-0.3,0.01-0.45,0.02c-0.13,0.01-0.26,0.01-0.39,0.02 c-0.04,0-0.09,0.01-0.13,0.01h-0.01c-0.1,0.01-0.19,0.02-0.29,0.02c-0.15,0.01-0.29,0.03-0.44,0.05 c-0.12,0.01-0.23,0.03-0.35,0.05c-0.12,0.02-0.24,0.03-0.36,0.05c-0.14,0.02-0.28,0.05-0.41,0.07c-0.74,0.14-1.46,0.31-2.16,0.54 c-0.11,0.03-0.22,0.07-0.33,0.11c-0.17,0.06-0.34,0.12-0.5,0.18c-0.1,0.03-0.2,0.07-0.29,0.11c-0.09,0.04-0.19,0.07-0.28,0.11 c-0.1,0.04-0.19,0.08-0.28,0.12c-0.15,0.06-0.3,0.13-0.45,0.2c-0.1,0.05-0.21,0.1-0.31,0.15c-0.1,0.05-0.21,0.1-0.31,0.15 c-0.13,0.07-0.26,0.14-0.39,0.2c-0.13,0.07-0.25,0.14-0.38,0.21c-0.04,0.02-0.08,0.05-0.12,0.07c-0.13,0.07-0.26,0.15-0.39,0.23 c-0.02,0.01-0.04,0.02-0.06,0.04c-0.14,0.09-0.28,0.17-0.41,0.27c-0.03,0.02-0.06,0.04-0.09,0.06c-0.07,0.05-0.15,0.1-0.23,0.16 C9.8,5.59,9.77,5.61,9.73,5.64C9.69,5.66,9.65,5.69,9.61,5.72c-0.14,0.1-0.28,0.21-0.42,0.31C9.18,6.04,9.15,6.06,9.13,6.08 C8.99,6.19,8.85,6.3,8.71,6.41C8.57,6.52,8.44,6.63,8.31,6.74C8.3,6.76,8.28,6.77,8.26,6.79C8.12,6.91,7.97,7.04,7.83,7.17 c0,0,0,0-0.01,0.01c-0.14,0.13-0.28,0.26-0.41,0.4c-0.28,0.27-0.54,0.55-0.8,0.84C6.5,8.56,6.38,8.69,6.27,8.82 C6.24,8.85,6.22,8.88,6.2,8.91C6.09,9.05,5.98,9.18,5.87,9.32C5.75,9.47,5.64,9.63,5.52,9.78c-0.11,0.15-0.22,0.31-0.33,0.46 c-0.01,0.02-0.03,0.04-0.04,0.06c-0.1,0.14-0.19,0.29-0.29,0.44c0,0-0.01,0.01-0.01,0.01c-0.1,0.16-0.2,0.33-0.3,0.49 c-0.1,0.17-0.2,0.34-0.29,0.51c-0.01,0.01-0.01,0.02-0.02,0.04c-0.08,0.15-0.16,0.31-0.24,0.46C4,12.28,3.99,12.3,3.98,12.32 c-0.08,0.16-0.16,0.32-0.23,0.48c-0.08,0.18-0.16,0.36-0.24,0.54c-0.01,0.01-0.01,0.02-0.01,0.03c-0.07,0.16-0.14,0.33-0.2,0.5 c-0.01,0.02-0.02,0.04-0.02,0.06c-0.06,0.15-0.11,0.3-0.16,0.45c-0.02,0.04-0.03,0.09-0.05,0.13c-0.04,0.13-0.09,0.26-0.13,0.39 c-0.02,0.04-0.03,0.09-0.05,0.14c-0.05,0.18-0.1,0.35-0.15,0.53c-0.01,0.02-0.01,0.04-0.01,0.05c-0.04,0.15-0.09,0.31-0.12,0.47 c-0.06,0.24-0.12,0.48-0.16,0.73c-0.04,0.17-0.07,0.35-0.1,0.53c-0.03,0.16-0.05,0.32-0.07,0.48c-0.01,0.09-0.03,0.19-0.04,0.28 c-0.03,0.21-0.05,0.42-0.07,0.63c-0.01,0.12-0.02,0.24-0.03,0.36c-0.01,0.09-0.01,0.19-0.02,0.28c-0.01,0.15-0.02,0.31-0.02,0.47 c-0.01,0.19-0.01,0.39-0.01,0.58c0,9.98,8.09,18.07,18.07,18.07s18.07-8.09,18.07-18.07S30.12,2.34,20.14,2.34z M20.14,36.4 c-8.82,0-16-7.18-16-16c0-5.45,2.74-10.27,6.91-13.16c0.07-0.06,0.15-0.1,0.23-0.16c2.32-1.54,5.05-2.5,8-2.65 c0.1-0.01,0.2-0.01,0.3-0.01c0.18-0.01,0.37-0.01,0.56-0.01c8.82,0,16,7.18,16,16C36.14,29.23,28.96,36.4,20.14,36.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: -25.8444,
    cy: 18.411,
    r: 9.3021,
    gradientTransform: "matrix(3.8462 0 0 3.8462 119.9822 -49.7337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.49,0l-0.81,2.4c-0.1,0.01-0.2,0.02-0.3,0.02c-0.15,0.01-0.29,0.03-0.44,0.05 c-0.12,0.01-0.23,0.03-0.35,0.05c-0.12,0.02-0.24,0.03-0.36,0.05c-0.14,0.02-0.28,0.05-0.41,0.07c-0.74,0.14-1.46,0.31-2.16,0.54 c-0.11,0.03-0.22,0.07-0.33,0.11c-0.17,0.06-0.34,0.12-0.5,0.18c-0.1,0.03-0.2,0.07-0.29,0.11c-0.09,0.04-0.19,0.07-0.28,0.11 c-0.1,0.04-0.19,0.08-0.28,0.12c-0.15,0.06-0.3,0.13-0.45,0.2c-0.1,0.05-0.21,0.1-0.31,0.15c-0.1,0.05-0.21,0.1-0.31,0.15 c-0.13,0.07-0.26,0.14-0.39,0.2c-0.13,0.07-0.25,0.14-0.38,0.21c-0.04,0.02-0.08,0.05-0.12,0.07c-0.13,0.07-0.26,0.15-0.39,0.23 c-0.02,0.01-0.04,0.02-0.06,0.04c-0.14,0.09-0.28,0.17-0.41,0.27c-0.03,0.02-0.06,0.04-0.09,0.06C9.95,5.48,9.84,5.56,9.73,5.64 C8.81,5.18,7.7,5.12,6.5,5.22l0.48-0.4c0.9-0.76,1.85-1.44,2.85-2.02c2.05-1.21,4.27-2.04,6.6-2.47 c0.89-0.16,1.78-0.27,2.66-0.31L19.49,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.0944,
    y1: 5.9411,
    x2: 37.5925,
    y2: -7.0682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M19.7,4.69l-0.4,0.02c-2.8,0.14-5.52,1.05-7.86,2.61l-0.22,0.15c0,0-1.02-1.25-1.49-1.82 C9.8,5.58,9.99,5.46,10.07,5.4c0.03-0.02,0.06-0.04,0.09-0.06c0.14-0.09,0.27-0.18,0.41-0.27c0.02-0.01,0.04-0.03,0.06-0.04 c0.13-0.08,0.26-0.16,0.39-0.23c0.04-0.02,0.08-0.05,0.12-0.07c0.13-0.07,0.25-0.14,0.38-0.21c0.13-0.07,0.26-0.14,0.39-0.2 c0.1-0.05,0.2-0.1,0.31-0.15c0.1-0.05,0.21-0.1,0.31-0.15c0.15-0.07,0.3-0.14,0.45-0.2c0.09-0.04,0.19-0.08,0.28-0.12 c0.09-0.04,0.18-0.08,0.28-0.11c0.1-0.04,0.19-0.08,0.29-0.11c0.17-0.06,0.33-0.12,0.5-0.18c0.11-0.04,0.22-0.07,0.33-0.11 c0.7-0.22,1.42-0.4,2.16-0.54c0.14-0.02,0.27-0.05,0.41-0.07c0.12-0.02,0.24-0.04,0.36-0.05c0.12-0.02,0.23-0.03,0.35-0.05 c0.14-0.02,0.29-0.03,0.44-0.05c0.1-0.01,0.19-0.02,0.29-0.02l0.91,2.02L19.7,4.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.3639,
    y1: 3.3748,
    x2: 15.8978,
    y2: 1.5107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.23,2.98c1.86-1.06,3.86-1.8,5.95-2.21c-0.38,0.72-0.1,1.16,0.56,1.44c-1.99,0.36-3.9,1.04-5.67,2.03 L10.23,2.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.3361,
    y1: 4.3317,
    x2: 13.7666,
    y2: 1.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M9.82,3.22l0.91,1.19l-0.67,0.4C9.58,4.39,9.09,4.16,8.6,4.04C8.96,3.76,9.36,3.48,9.82,3.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1886,
    y1: 13.8545,
    x2: 10.4661,
    y2: 8.7408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M6.5,5.22L6.45,5.53c1.03-0.04,2.2-0.04,3.04,0.28l1.37,1.57l0.35,0.08L9.73,5.64 C8.89,5.12,7.75,5.09,6.5,5.22z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st364",
    points: "19.49,0 19.55,0.27 18.88,2.39 19.74,4.41 19.7,4.69 18.67,2.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8885,
    y1: 2.4568,
    x2: 8.9054,
    y2: 5.5442
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE1BF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M9.83,5.76l-0.1-0.12L9.6,5.57c4.49-3.23,9.07-3.29,9.11-3.29l-0.04,0.14l0.06,0.12 C18.69,2.53,14.24,2.58,9.83,5.76z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: -25.9819,
    cy: 17.9737,
    r: 6.4526,
    gradientTransform: "matrix(3.8462 0 0 3.8462 119.9822 -49.7337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M6.23,5.44c0,0-0.92,0.68-1.94,2.24C5.68,7.84,9.31,5.7,9.31,5.7S8.51,5.38,6.23,5.44z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.1026,
    y1: 6.6453,
    x2: 5.3069,
    y2: 6.7844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M4.28,7.69l0.08,0.22c0,0,0.98,0.2,1.87-0.21c0.9-0.42,3.26-1.89,3.26-1.89L9.31,5.7 c0,0-3.07,1.66-3.72,1.76C4.94,7.57,4.28,7.69,4.28,7.69z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_173_",
    d: "M19.09,1.73c0,0,2.79-0.12,5.6,0.61c2.39,0.62,2.47,1.01,3.43,1.22c0.86,0.19,1.61-0.13,1.61-0.13 s-1.93-1.46-5.52-2.15c-3.59-0.69-4.83-0.48-4.83-0.48L19.09,1.73z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_173_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D09A7C"
    },
    points: "29.72,3.75 29.73,3.75 29.73,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D19B7D"
    },
    points: "29.27,3.75 29.73,3.38 29.73,3.75 29.72,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D29D7E"
    },
    points: "28.82,3.75 29.73,3.01 29.73,3.38 29.27,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D49E7F"
    },
    points: "28.37,3.75 29.73,2.64 29.73,3.01 28.82,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D59F81"
    },
    points: "27.91,3.75 29.59,2.38 29.73,2.55 29.73,2.64 28.37,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D6A182"
    },
    points: "27.46,3.75 29.41,2.16 29.59,2.38 27.91,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D8A283"
    },
    points: "27.01,3.75 29.22,1.94 29.41,2.16 27.46,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#D9A385"
    },
    points: "26.56,3.75 29.04,1.72 29.22,1.94 27.01,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#DAA586"
    },
    points: "26.11,3.75 28.86,1.5 29.04,1.72 26.56,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#DCA687"
    },
    points: "25.65,3.75 28.68,1.27 28.86,1.5 26.11,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#DDA789"
    },
    points: "25.2,3.75 28.5,1.05 28.68,1.27 25.65,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#DEA88A"
    },
    points: "24.75,3.75 28.32,0.83 28.5,1.05 25.2,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E0AA8B"
    },
    points: "24.3,3.75 28.14,0.61 28.32,0.83 24.75,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E1AB8D"
    },
    points: "23.84,3.75 27.73,0.58 28.11,0.58 28.14,0.61 24.3,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E2AC8E"
    },
    points: "23.39,3.75 27.27,0.58 27.73,0.58 23.84,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E3AE8F"
    },
    points: "22.94,3.75 26.82,0.58 27.27,0.58 23.39,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E5AF90"
    },
    points: "22.49,3.75 26.37,0.58 26.82,0.58 22.94,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E6B092"
    },
    points: "22.04,3.75 25.92,0.58 26.37,0.58 22.49,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E7B293"
    },
    points: "21.58,3.75 25.47,0.58 25.92,0.58 22.04,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#E9B394"
    },
    points: "21.13,3.75 25.01,0.58 25.47,0.58 21.58,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#EAB496"
    },
    points: "20.68,3.75 24.56,0.58 25.01,0.58 21.13,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#EBB597"
    },
    points: "20.23,3.75 24.11,0.58 24.56,0.58 20.68,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#EDB798"
    },
    points: "20.03,3.75 19.93,3.63 23.66,0.58 24.11,0.58 20.23,3.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#EEB89A"
    },
    points: "19.93,3.63 19.74,3.41 23.2,0.58 23.66,0.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#EFB99B"
    },
    points: "19.74,3.41 19.56,3.18 22.75,0.58 23.2,0.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F1BB9C"
    },
    points: "19.56,3.18 19.38,2.96 22.3,0.58 22.75,0.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F2BC9E"
    },
    points: "19.38,2.96 19.2,2.74 21.85,0.58 22.3,0.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F3BD9F"
    },
    points: "19.2,2.74 19.09,2.6 19.09,2.46 21.4,0.58 21.85,0.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F4BFA0"
    },
    points: "19.09,2.09 20.94,0.58 21.4,0.58 19.09,2.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F6C0A1"
    },
    points: "19.09,1.72 20.49,0.58 20.94,0.58 19.09,2.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F7C1A3"
    },
    points: "19.09,1.35 20.04,0.58 20.49,0.58 19.09,1.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#F8C3A4"
    },
    points: "19.09,0.98 19.59,0.58 20.04,0.58 19.09,1.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#FAC4A5"
    },
    points: "19.09,0.61 19.14,0.58 19.59,0.58 19.09,0.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_17_)",
      fill: "#FBC5A7"
    },
    points: "19.14,0.58 19.09,0.61 19.09,0.58  "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M28.68,3.76c-0.19,0-0.39-0.02-0.59-0.06c-0.41-0.09-0.66-0.21-0.98-0.36c-0.44-0.21-1.05-0.5-2.45-0.86 c-2.76-0.71-5.53-0.6-5.56-0.6l-0.2,0.01l0.37-1.21l0.08-0.01c0.05-0.01,1.3-0.21,4.88,0.48c3.58,0.69,5.5,2.12,5.58,2.18 L30,3.46l-0.22,0.09C29.76,3.56,29.3,3.76,28.68,3.76z M19.54,1.59c0.91,0,3.05,0.07,5.18,0.62c1.43,0.37,2.05,0.66,2.5,0.88 c0.32,0.15,0.55,0.26,0.92,0.34c0.52,0.11,0.99,0.03,1.27-0.04c-0.6-0.39-2.41-1.43-5.24-1.98c-3.01-0.58-4.37-0.52-4.7-0.49 l-0.21,0.67C19.35,1.59,19.44,1.59,19.54,1.59z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.07,
    y1: 5.7729,
    x2: 23.9121,
    y2: 1.1326
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F694B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M30.92,3.11l-0.07,0.24c0,0-0.85,0.15-1.7,0c-0.85-0.15-2.41-1.1-4.78-1.62c-2.95-0.65-5.16-0.52-5.16-0.52 l0.18-0.46C19.39,0.76,25.79,0.78,30.92,3.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4515,
    y1: 12.2744,
    x2: 10.7749,
    y2: -7.5562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M19.65,0c4.23,0.16,8.2,0.8,11.27,3.11c0,0-1.41,0.33-2.33-0.15c-3.84-1.97-9.27-2-9.27-2L19.65,0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2739,
    y1: 9.2818,
    x2: 2.5601,
    y2: 2.2933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M5.61,6.31c0,0-0.8,0.74-0.61,0.89c0.2,0.15,2.46-0.82,2.46-0.82S5.69,6.93,5.61,6.31z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_21_",
    cx: 239.9046,
    cy: -165.6962,
    r: 9.3025,
    gradientTransform: "matrix(-3.8317 -0.3326 0.3326 -3.8317 993.9126 -535.5449)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M18.82,40.66l1.01-2.32c0.1,0,0.2,0,0.3,0c0.15,0,0.29,0,0.44-0.01c0.12,0,0.23-0.01,0.35-0.02 c0.12-0.01,0.24-0.01,0.36-0.02c0.14-0.01,0.28-0.02,0.42-0.04c0.75-0.07,1.48-0.19,2.2-0.35c0.11-0.02,0.23-0.05,0.34-0.08 c0.17-0.04,0.35-0.09,0.52-0.14c0.1-0.02,0.2-0.05,0.3-0.08c0.1-0.03,0.19-0.06,0.29-0.09c0.1-0.03,0.2-0.06,0.29-0.09 c0.16-0.05,0.31-0.11,0.47-0.16c0.11-0.04,0.22-0.08,0.33-0.12c0.11-0.04,0.22-0.08,0.32-0.13c0.13-0.05,0.27-0.11,0.4-0.17 c0.13-0.06,0.27-0.12,0.4-0.18c0.04-0.02,0.09-0.04,0.13-0.06c0.14-0.06,0.27-0.13,0.41-0.2c0.02-0.01,0.04-0.02,0.06-0.03 c0.15-0.07,0.29-0.15,0.44-0.23c0.03-0.01,0.06-0.03,0.09-0.05c0.12-0.07,0.24-0.13,0.36-0.2c0.87,0.54,1.98,0.69,3.18,0.7 l-0.51,0.36c-0.96,0.68-1.97,1.27-3.01,1.76c-2.15,1.03-4.43,1.66-6.79,1.89c-0.9,0.09-1.8,0.11-2.68,0.08L18.82,40.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.5409,
    y1: -178.9718,
    x2: 211.0379,
    y2: -191.9805,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M19.01,35.97l0.4,0.01c2.8,0.1,5.59-0.56,8.06-1.92l0.23-0.13c0,0,0.91,1.34,1.32,1.95 c-0.08,0.05-0.28,0.16-0.36,0.2c-0.03,0.02-0.06,0.04-0.09,0.05c-0.14,0.08-0.29,0.16-0.44,0.23c-0.02,0.01-0.04,0.02-0.06,0.03 c-0.14,0.07-0.27,0.14-0.41,0.2c-0.04,0.02-0.09,0.04-0.13,0.06c-0.13,0.06-0.27,0.12-0.4,0.18c-0.13,0.06-0.27,0.12-0.4,0.17 c-0.11,0.04-0.21,0.09-0.32,0.13c-0.11,0.04-0.22,0.08-0.33,0.12c-0.15,0.06-0.31,0.11-0.47,0.16c-0.1,0.03-0.19,0.06-0.29,0.09 c-0.09,0.03-0.19,0.06-0.29,0.09c-0.1,0.03-0.2,0.06-0.3,0.08c-0.17,0.05-0.34,0.09-0.52,0.14c-0.11,0.03-0.22,0.06-0.34,0.08 c-0.72,0.16-1.45,0.28-2.2,0.35c-0.14,0.01-0.28,0.03-0.42,0.04c-0.12,0.01-0.24,0.02-0.36,0.02c-0.12,0.01-0.23,0.01-0.35,0.02 c-0.14,0.01-0.29,0.01-0.44,0.01c-0.1,0-0.19,0-0.29,0l-0.73-2.09L19.01,35.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 184.8105,
    y1: -181.5379,
    x2: 189.3441,
    y2: -183.402,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M28.3,38.49c-1.94,0.89-4,1.46-6.12,1.69c0.44-0.68,0.2-1.15-0.44-1.48c2.01-0.18,3.97-0.7,5.83-1.54 L28.3,38.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.7828,
    y1: -180.581,
    x2: 187.2132,
    y2: -182.9337,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M28.73,38.29l-0.8-1.26l0.7-0.34c0.44,0.46,0.9,0.73,1.38,0.89C29.64,37.82,29.21,38.06,28.73,38.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.6351,
    y1: -171.0587,
    x2: 183.9128,
    y2: -176.1721,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M32.22,36.58l0.07-0.31c-1.03-0.05-2.2-0.15-3-0.54l-1.23-1.68l-0.35-0.11l1.32,1.95 C29.82,36.47,30.96,36.6,32.22,36.58z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st364",
    points: "18.82,40.66 18.79,40.38 19.63,38.33 18.95,36.24 19.01,35.97 19.84,38.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.3349,
    y1: -182.4559,
    x2: 182.3522,
    y2: -179.3686,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF0BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE1BF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M28.95,35.75l0.09,0.13l0.12,0.08c-4.75,2.83-9.32,2.5-9.36,2.49l0.05-0.13l-0.05-0.12 C19.84,38.2,24.27,38.53,28.95,35.75z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 239.7671,
    cy: -166.1335,
    r: 6.4528,
    gradientTransform: "matrix(-3.8317 -0.3326 0.3326 -3.8317 993.9126 -535.5449)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M32.51,36.38c0,0,0.98-0.59,2.13-2.07c-1.38-0.27-5.18,1.54-5.18,1.54S30.22,36.24,32.51,36.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.3447,
    y1: -178.2675,
    x2: 178.7539,
    y2: -178.1283,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M34.64,34.31l-0.06-0.23c0,0-0.95-0.29-1.88,0.05c-0.93,0.34-3.41,1.6-3.41,1.6l0.17,0.12 c0,0,3.2-1.39,3.86-1.43C33.97,34.37,34.64,34.31,34.64,34.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_186_",
    d: "M19.37,38.96c0,0-2.79-0.12-5.53-1.09c-2.33-0.82-2.37-1.22-3.31-1.51c-0.84-0.26-1.61,0-1.61,0 s1.8,1.62,5.31,2.62c3.52,1,4.77,0.9,4.77,0.9L19.37,38.96z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D09A7C"
    },
    points: "8.95,36.03 8.95,36.04 8.95,36.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D19B7D"
    },
    points: "9.4,36.07 8.92,36.41 8.95,36.04 8.95,36.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D29D7E"
    },
    points: "9.85,36.11 8.88,36.77 8.92,36.41 9.4,36.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D49E7F"
    },
    points: "10.3,36.15 8.85,37.14 8.88,36.77 9.85,36.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D59F81"
    },
    points: "10.75,36.19 8.97,37.41 8.85,37.23 8.85,37.14 10.3,36.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D6A182"
    },
    points: "11.2,36.23 9.13,37.65 8.97,37.41 10.75,36.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D8A283"
    },
    points: "11.66,36.27 9.29,37.88 9.13,37.65 11.2,36.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#D9A385"
    },
    points: "12.11,36.31 9.45,38.12 9.29,37.88 11.66,36.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#DAA586"
    },
    points: "12.56,36.35 9.61,38.35 9.45,38.12 12.11,36.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#DCA687"
    },
    points: "13.01,36.39 9.78,38.59 9.61,38.35 12.56,36.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#DDA789"
    },
    points: "13.46,36.43 9.94,38.83 9.78,38.59 13.01,36.39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#DEA88A"
    },
    points: "13.91,36.46 10.1,39.06 9.94,38.83 13.46,36.43  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E0AA8B"
    },
    points: "14.36,36.5 10.26,39.3 10.1,39.06 13.91,36.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E1AB8D"
    },
    points: "14.81,36.54 10.67,39.37 10.28,39.34 10.26,39.3 14.36,36.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E2AC8E"
    },
    points: "15.26,36.58 11.12,39.41 10.67,39.37 14.81,36.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E3AE8F"
    },
    points: "15.71,36.62 11.57,39.45 11.12,39.41 15.26,36.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E5AF90"
    },
    points: "16.16,36.66 12.02,39.49 11.57,39.45 15.71,36.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E6B092"
    },
    points: "16.61,36.7 12.47,39.53 12.02,39.49 16.16,36.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E7B293"
    },
    points: "17.06,36.74 12.92,39.56 12.47,39.53 16.61,36.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#E9B394"
    },
    points: "17.51,36.78 13.37,39.6 12.92,39.56 17.06,36.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#EAB496"
    },
    points: "17.96,36.82 13.82,39.64 13.37,39.6 17.51,36.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#EBB597"
    },
    points: "18.41,36.86 14.27,39.68 13.82,39.64 17.96,36.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#EDB798"
    },
    points: "18.61,36.87 18.7,37 14.72,39.72 14.27,39.68 18.41,36.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#EEB89A"
    },
    points: "18.7,37 18.86,37.24 15.17,39.76 14.72,39.72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#EFB99B"
    },
    points: "18.86,37.24 19.02,37.48 15.62,39.8 15.17,39.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F1BB9C"
    },
    points: "19.02,37.48 19.19,37.71 16.07,39.84 15.62,39.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F2BC9E"
    },
    points: "19.19,37.71 19.35,37.95 16.52,39.88 16.07,39.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F3BD9F"
    },
    points: "19.35,37.95 19.45,38.1 19.43,38.24 16.97,39.92  16.52,39.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F4BFA0"
    },
    points: "19.4,38.61 17.42,39.96 16.97,39.92 19.43,38.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F6C0A1"
    },
    points: "19.37,38.97 17.87,39.99 17.42,39.96 19.4,38.61  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F7C1A3"
    },
    points: "19.34,39.34 18.32,40.03 17.87,39.99 19.37,38.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#F8C3A4"
    },
    points: "19.31,39.71 18.77,40.07 18.32,40.03 19.34,39.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#FAC4A5"
    },
    points: "19.27,40.08 19.23,40.11 18.77,40.07 19.31,39.71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_29_)",
      fill: "#FBC5A7"
    },
    points: "19.23,40.11 19.27,40.08 19.27,40.12  "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st364",
    d: "M9.99,36.12c0.19,0.02,0.38,0.05,0.59,0.11c0.4,0.12,0.64,0.27,0.94,0.44c0.42,0.25,1,0.59,2.37,1.07 c2.69,0.95,5.46,1.08,5.49,1.08l0.2,0.01l-0.48,1.17l-0.08,0.01c-0.05,0-1.32,0.1-4.82-0.9c-3.51-1-5.29-2.59-5.37-2.65 L8.65,36.3l0.22-0.08C8.9,36.22,9.37,36.06,9.99,36.12z M18.91,39.07c-0.91-0.08-3.04-0.33-5.11-1.06 c-1.39-0.49-1.98-0.84-2.42-1.09c-0.3-0.18-0.52-0.3-0.89-0.42c-0.5-0.16-0.98-0.12-1.27-0.07c0.57,0.44,2.27,1.63,5.05,2.42 c2.95,0.84,4.3,0.9,4.64,0.89l0.26-0.65C19.1,39.09,19.01,39.08,18.91,39.07z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.5156,
    y1: -179.1404,
    x2: 197.3581,
    y2: -183.7804,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F694B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M7.7,36.56l0.09-0.24c0,0,0.86-0.08,1.69,0.15c0.83,0.22,2.31,1.3,4.62,2.02c2.89,0.9,5.1,0.96,5.1,0.96 l-0.22,0.44C18.99,39.9,12.61,39.34,7.7,36.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.8965,
    y1: -172.6392,
    x2: 184.2216,
    y2: -192.4687,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7A4425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#FFE1BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB7557"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M18.66,40.64c-4.2-0.53-8.1-1.51-10.96-4.08c0,0,1.43-0.2,2.31,0.35c3.65,2.3,9.06,2.79,9.06,2.79 L18.66,40.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.7206,
    y1: -175.6311,
    x2: 176.0073,
    y2: -182.619,
    gradientTransform: "matrix(-0.9963 -0.0865 0.0865 -0.9963 227.0393 -126.8844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M33.19,35.57c0,0,0.86-0.66,0.68-0.83c-0.18-0.17-2.52,0.61-2.52,0.61S33.17,34.95,33.19,35.57z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.5744,
    y1: 22.5128,
    x2: 1.416,
    y2: 12.5898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1.79,20.4c0-0.2,0-0.39,0.01-0.58c0-0.16,0.01-0.32,0.02-0.47c0-0.1,0.01-0.2,0.02-0.28 c0.01-0.13,0.02-0.25,0.03-0.37c0.02-0.21,0.04-0.43,0.07-0.64c0.01-0.09,0.03-0.19,0.04-0.28c0.02-0.16,0.05-0.33,0.08-0.49 c0.03-0.18,0.06-0.36,0.1-0.53c0.04-0.23,0.1-0.48,0.16-0.73c0.04-0.16,0.08-0.32,0.12-0.48c0.01-0.02,0.01-0.05,0.02-0.06 c0.05-0.18,0.1-0.36,0.16-0.55l0.02-0.06c0.01-0.03,0.02-0.06,0.02-0.07c0.02-0.05,0.03-0.1,0.05-0.15L1.2,14.43 c-0.61,1.91-0.92,3.9-0.92,5.92L1.79,20.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.1828,
    y1: 22.5191,
    x2: 1.0244,
    y2: 12.5961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFABF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B0500"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M2.05,23.42c-0.1-0.58-0.17-1.17-0.21-1.77l-1.52,0.02c0.04,0.63,0.12,1.26,0.22,1.88L2.05,23.42z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.6631,
    y1: -128.6882,
    x2: 185.896,
    y2: -144.293,
    gradientTransform: "matrix(-0.9999 0.0137 -0.0137 -0.9999 222.7803 -121.9112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M38.54,20.11c0,0.2,0,0.39,0,0.58c0,0.16-0.01,0.32-0.02,0.47c0,0.1-0.01,0.2-0.01,0.28 c0,0.13-0.01,0.25-0.03,0.37c-0.01,0.21-0.03,0.43-0.06,0.64c-0.01,0.09-0.02,0.19-0.04,0.28c-0.02,0.16-0.04,0.33-0.07,0.49 c-0.03,0.18-0.06,0.36-0.09,0.53c-0.04,0.24-0.09,0.48-0.15,0.74c-0.03,0.16-0.07,0.32-0.12,0.48c0,0.02-0.01,0.05-0.02,0.06 c-0.05,0.18-0.1,0.36-0.15,0.55l-0.02,0.06c-0.01,0.03-0.02,0.06-0.02,0.07c-0.01,0.05-0.03,0.1-0.05,0.15l1.52,0.21 c0.58-1.92,0.86-3.91,0.84-5.94L38.54,20.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.428,
    y1: -128.6915,
    x2: 185.6609,
    y2: -144.2966,
    gradientTransform: "matrix(-0.9999 0.0137 -0.0137 -0.9999 222.7803 -121.9112)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3BD9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    style: {
      stopColor: "#6C3618"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M38.25,17.1c0.1,0.58,0.19,1.17,0.24,1.76L40,18.82c-0.05-0.63-0.13-1.26-0.24-1.88L38.25,17.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9947,
    y1: 49.3432,
    x2: 47.6318,
    y2: 49.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M10.62,46.91c0.27,0,0.27,0,0.51,0.11c0.24,0.1,0.24,0.1,0.41,0.28c0.18,0.17,0.18,0.17,0.28,0.41 c0.11,0.24,0.11,0.24,0.11,0.51c0,0.35,0,0.35-0.17,0.64c-0.16,0.29-0.16,0.29-0.44,0.46c0.32,0.16,0.32,0.16,0.51,0.47 c0.2,0.31,0.2,0.31,0.2,0.68c0,0.27,0,0.27-0.11,0.51c-0.1,0.23-0.1,0.23-0.28,0.41c-0.17,0.17-0.17,0.17-0.41,0.28 c-0.24,0.1-0.24,0.1-0.51,0.1H9.01v-2.25v-0.35v-2.26H10.62z M10.73,49.52c-0.03,0-0.03,0-0.05,0.01c-0.03,0-0.03,0-0.05,0H9.35 v1.91h1.38c0.2,0,0.2,0,0.37-0.07c0.17-0.07,0.17-0.07,0.3-0.2c0.13-0.13,0.13-0.13,0.21-0.31c0.08-0.18,0.08-0.18,0.08-0.38 c0-0.2,0-0.2-0.08-0.37c-0.07-0.17-0.07-0.17-0.21-0.3c-0.13-0.13-0.13-0.13-0.3-0.21C10.93,49.52,10.93,49.52,10.73,49.52z  M10.62,49.17c0.2,0,0.2,0,0.37-0.07c0.17-0.07,0.17-0.07,0.3-0.2c0.13-0.13,0.13-0.13,0.21-0.31c0.07-0.17,0.07-0.17,0.07-0.37 c0-0.2,0-0.2-0.07-0.37c-0.07-0.17-0.07-0.17-0.21-0.3c-0.13-0.13-0.13-0.13-0.3-0.21c-0.17-0.08-0.17-0.08-0.37-0.08H9.35v1.91 H10.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9947,
    y1: 49.3432,
    x2: 47.632,
    y2: 49.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M12.61,46.91h1.61c0.27,0,0.27,0,0.51,0.11c0.24,0.1,0.24,0.1,0.41,0.28c0.18,0.17,0.18,0.17,0.28,0.41 c0.11,0.24,0.11,0.24,0.11,0.51c0,0.24,0,0.24-0.08,0.46c-0.08,0.21-0.08,0.21-0.23,0.39c-0.15,0.17-0.15,0.17-0.35,0.28 c-0.19,0.11-0.19,0.11-0.42,0.15h0.02l0.98,2.28h-0.38l-0.97-2.25h-1.14v2.25h-0.35V46.91z M12.96,49.17h1.26 c0.2,0,0.2,0,0.37-0.07c0.17-0.07,0.17-0.07,0.3-0.2c0.13-0.13,0.13-0.13,0.21-0.31c0.08-0.17,0.08-0.17,0.08-0.37 c0-0.2,0-0.2-0.08-0.37c-0.07-0.17-0.07-0.17-0.21-0.3c-0.13-0.13-0.13-0.13-0.3-0.21c-0.17-0.08-0.17-0.08-0.37-0.08h-1.26V49.17 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9948,
    y1: 49.3499,
    x2: 47.6315,
    y2: 49.3499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M19.52,50.11c0,0.36,0,0.36-0.14,0.68c-0.13,0.31-0.13,0.31-0.37,0.55c-0.23,0.23-0.23,0.23-0.55,0.37 c-0.31,0.13-0.31,0.13-0.67,0.13c-0.36,0-0.36,0-0.68-0.13c-0.32-0.14-0.32-0.14-0.56-0.37c-0.23-0.24-0.23-0.24-0.37-0.55 c-0.13-0.32-0.13-0.32-0.13-0.68v-1.53c0-0.36,0-0.36,0.13-0.67c0.14-0.32,0.14-0.32,0.37-0.55c0.24-0.24,0.24-0.24,0.56-0.37 c0.32-0.14,0.32-0.14,0.68-0.14c0.36,0,0.36,0,0.67,0.14c0.32,0.13,0.32,0.13,0.55,0.37c0.24,0.23,0.24,0.23,0.37,0.55 c0.14,0.31,0.14,0.31,0.14,0.67V50.11z M19.18,48.59c0-0.29,0-0.29-0.11-0.54c-0.11-0.25-0.11-0.25-0.3-0.44 c-0.19-0.19-0.19-0.19-0.44-0.3c-0.25-0.11-0.25-0.11-0.54-0.11c-0.29,0-0.29,0-0.55,0.11c-0.25,0.11-0.25,0.11-0.44,0.3 c-0.19,0.19-0.19,0.19-0.3,0.44c-0.11,0.25-0.11,0.25-0.11,0.54v1.53c0,0.29,0,0.29,0.11,0.54c0.11,0.25,0.11,0.25,0.3,0.45 c0.19,0.19,0.19,0.19,0.44,0.3c0.25,0.11,0.25,0.11,0.55,0.11c0.29,0,0.29,0,0.54-0.11c0.25-0.11,0.25-0.11,0.44-0.3 c0.19-0.19,0.19-0.19,0.3-0.45c0.11-0.25,0.11-0.25,0.11-0.54V48.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9948,
    y1: 49.3167,
    x2: 47.6313,
    y2: 49.3167
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M23.35,48.59c0-0.29,0-0.29-0.11-0.54c-0.11-0.25-0.11-0.25-0.3-0.44c-0.19-0.19-0.19-0.19-0.44-0.3 c-0.25-0.11-0.25-0.11-0.54-0.11c-0.29,0-0.29,0-0.55,0.11c-0.25,0.11-0.25,0.11-0.44,0.3c-0.19,0.19-0.19,0.19-0.3,0.44 c-0.11,0.25-0.11,0.25-0.11,0.54v3.18h-0.35v-3.18c0-0.36,0-0.36,0.13-0.67c0.14-0.32,0.14-0.32,0.37-0.55 c0.24-0.24,0.24-0.24,0.55-0.37c0.32-0.14,0.32-0.14,0.68-0.14c0.36,0,0.36,0,0.67,0.14c0.32,0.13,0.32,0.13,0.55,0.37 c0.24,0.23,0.24,0.23,0.37,0.55c0.14,0.31,0.14,0.31,0.14,0.67v3.18h-0.35V48.59z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9944,
    y1: 49.3432,
    x2: 47.6318,
    y2: 49.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_42_)"
    },
    points: "27.18,46.91 27.58,46.91 26.78,48.31 26.78,48.31 24.98,51.43 27.68,51.43  27.68,51.78 24.78,51.78 24.78,51.78 24.78,51.78 24.37,51.78 26.37,48.31 26.98,47.26 24.72,47.26 24.72,46.91  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9946,
    y1: 49.3432,
    x2: 47.6318,
    y2: 49.3432
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B0553D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BF765A"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st75",
    points: "28.35,47.09 28.35,47.09 28.35,46.91 31.27,46.91 31.27,47.26 28.7,47.26 28.7,49.17 30.94,49.17  30.94,49.52 28.7,49.52 28.7,51.43 31.27,51.43 31.27,51.78 28.35,51.78 28.35,51.78 28.35,51.78  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.fac34784cca549c0d0182007ed525551.svg";
export { ForwardRef as ReactComponent };